import { Component, OnInit, Input, OnChanges, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit, OnChanges {

  @Input() file: any
  @ViewChild('img') img: ElementRef
  @ViewChild('video') video: ElementRef
  public type: string = 'image'

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (/image/i.test(this.file._file.type)) {
        var reader = new FileReader();
        reader.onload = (function (theImg) {
            return function (evt) {
              theImg.nativeElement.src = evt.target.result;
            };
        }(this.img));
        reader.readAsDataURL(this.file._file);
        this.type = 'image';
    }
    if (/video/i.test(this.file._file.type)) {
        this.video.nativeElement.src = URL.createObjectURL(this.file._file);
        this.type = 'video';
    }
  }

}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/components/preview/preview.component.ts